<template>
  <Modal v-model:isOpen="isOpen" modalId="create-driver-modal" maxWidth="2xl" @close="onClose">
    <template #title>New Driver</template>
    <template #content>
      <div class="tw-space-y-4">
        <div v-if="loadFormError"
          class="tw-rounded-xl tw-border tw-border-rose-200/70 tw-bg-rose-50 tw-px-4 tw-py-3 tw-text-sm tw-text-rose-900">
          {{ loadFormError }}
        </div>

        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">
          <div>
            <label for="createDriver_name" class="tw-text-sm tw-font-medium tw-text-slate-700">Driver Name
              (*required)</label>
            <input v-model="name" type="text" id="createDriver_name"
              class="tw-mt-1 tw-h-10 tw-w-full tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-text-sm tw-text-slate-900" />
          </div>

          <div>
            <label for="createDriver_phone" class="tw-text-sm tw-font-medium tw-text-slate-700">Driver Phone #
              (*required)</label>
            <input v-model="phone" id="createDriver_phone" type="text"
              class="tw-mt-1 tw-h-10 tw-w-full tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-text-sm tw-text-slate-900" />
          </div>
        </div>

        <div class="tw-flex tw-items-center tw-gap-2">
          <input type="checkbox" id="createDriver_isOwnerOperator" v-model="checked"
            class="tw-h-4 tw-w-4 tw-rounded tw-border-slate-300" />
          <label for="createDriver_isOwnerOperator" class="tw-text-sm tw-text-slate-700">Is Company Driver?</label>
        </div>

        <div class="tw-flex tw-items-center tw-justify-end tw-gap-2">
          <button type="button"
            class="tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50"
            @click="onClose">
            Cancel
          </button>
          <button type="button"
            class="tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
            @click="createNewDriver" :disabled="!(name && phone) || loading">
            Add New Driver
          </button>
        </div>

        <div v-if="loading" class="tw-text-sm tw-text-slate-600">Saving...</div>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/core/Modal/Modal.vue';
import { toSentenceCase } from '../../utils/formatter';
import CREATE_DRIVER from '../../gql/drivers/CreateDriver.gql';

export default defineComponent({
  name: 'CreateDriverModal',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'createdDriver'],
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
      loadFormError: null,
      textDanger: false,
      phone: null,
      name: null,
      company: null,
      checked: false,
    };
  },
  computed: {
    isOpen: {
      get(): boolean {
        return (this as any).open;
      },
      set(value: boolean) {
        if (!value) {
          (this as any).onClose();
        }
      },
    },
  },
  watch: {
    name(val) {
      if (val) {
        this.name = toSentenceCase(val);
      }
    },
    phone(phone) {
      if (phone) {
        if (phone.length >= 12) {
          this.phone = phone.substring(0, 12);
          return;
        }
        let newPhone = phone.replace(/\D/g, '');
        const match = newPhone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
        if (match) {
          newPhone = `${match[1]}${match[2] ? '-' : ''}${match[2]}${match[3] ? '-' : ''
            }${match[3]}`;
        }
        this.phone = newPhone;
      }
    },
  },
  methods: {
    onClose() {
      (this as any).$emit('close');
    },
    createNewDriver() {
      this.loading = true;

      let variables = {};
      variables = {
        module: 'CONTRAK',
        phone: this.phone,
        name: this.name,
      };

      (this as any).$apollo
        .mutate({
          mutation: CREATE_DRIVER,
          variables,
        })
        .then((data) => {
          console.log(data);
          this.loading = false;
          this.loadFormError = null;
          this.$emit('createdDriver');

          this.name = null;
          this.phone = null;
          this.company = null;

          this.onClose();
        })
        .catch((error) => {
          console.error(error);
          this.loadFormError = error;
          this.loading = false;
        });
    },
  },
});
</script>